/* The sticky bottom "Shop cases" button on the content pages (FAQs, contact, about, blog, policies, wishlist, account...) follows the iPhone the visitor
   already picked (same key as the menu, home page and product pages): "Shop iPhone 17 Pro Max" opens that phone's collection.
   With no phone saved it stays "Shop cases" and opens all products. */
(function () {
  'use strict';
  var KEY = 'user_selected_device_model';
  function model() {
    var m = '';
    try { m = (localStorage.getItem(KEY) || '').trim(); } catch (e) { m = ''; }
    return /iphone/i.test(m) ? m.replace(/iphone/ig, 'iPhone') : '';
  }
  function slug(m) { return m.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-cases'; }
  var ok = {};
  function exists(s) {
    if (s in ok) return Promise.resolve(ok[s]);
    var ck = 'pmdock_' + s;
    try { var c = sessionStorage.getItem(ck); if (c) { ok[s] = c === '1'; return Promise.resolve(ok[s]); } } catch (e) { e = 0; }
    return fetch('/collections/' + s + '/products.json?limit=1').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var y = !!(d && d.products && d.products.length);
      ok[s] = y;
      try { sessionStorage.setItem(ck, y ? '1' : '0'); } catch (e) { e = 0; }
      return y;
    }).catch(function () { return false; });
  }
  function apply() {
    var m = model();
    var docks = [].slice.call(document.querySelectorAll('.pmp-dock-a'));
    if (!docks.length) return;
    docks.forEach(function (a) {
      if (!a.hasAttribute('data-pmd-t')) { a.setAttribute('data-pmd-t', a.textContent.trim()); a.setAttribute('data-pmd-h', a.getAttribute('href') || ''); }
      var t0 = a.getAttribute('data-pmd-t'), h0 = a.getAttribute('data-pmd-h');
      /* only the generic shop buttons are touched; anything else on a dock stays as written */
      if (!/^(shop cases|back to shop)$/i.test(t0)) return;
      if (!m) { a.textContent = t0; a.setAttribute('href', h0); return; }
      var s = slug(m);
      exists(s).then(function (y) {
        if (!y) { a.textContent = t0; a.setAttribute('href', h0); return; }
        a.textContent = 'Shop ' + m;
        a.setAttribute('href', '/collections/' + s);
      });
    });
  }
  apply();
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  /* docks that are added by other scripts a moment later (policy pages) */
  if (window.MutationObserver) {
    var n = 0, mo = new MutationObserver(function () { if (document.querySelector('.pmp-dock-a:not([data-pmd-t])')) apply(); if (++n > 60) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 6000);
  }
  /* the phone can be changed while the page is open (menu, other tab) */
  window.addEventListener('storage', function (e) { if (e.key === KEY) apply(); });
  try {
    var set = Storage.prototype.setItem;
    Storage.prototype.setItem = function (k) { set.apply(this, arguments); if (k === KEY) setTimeout(apply, 0); };
  } catch (e) { e = 0; }
})();
